export enum FuelTypeMeasurementUnit
{
  Liter = 0,
  Kilogram = 1,
  KilowattHour = 2
}
